import { tsValidateArray, tsValidateBoolean, tsValidateEmail, tsValidateNonMandatoryObject, tsValidateNumber, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
export const Validator_Contact = {
    firstName: tsValidateString(undefined, false),
    lastName: tsValidateString(undefined, false),
    email: tsValidateEmail
};
const Validator_Address = {
    country: tsValidateString(),
    city: tsValidateString(),
    address: tsValidateString(-1, false),
    zipCode: tsValidateNumber(false),
    stateRequired: tsValidateBoolean(false),
    state: tsValidateNonMandatoryObject({
        label: tsValidateString(),
        initials: tsValidateString(-1, false),
    }),
};
const Validator_ModifiableProps = {
    name: tsValidateString(),
    alias: tsValidateString(),
    address: Validator_Address,
    webUrl: tsValidateString(undefined, false),
    webDomains: tsValidateArray(tsValidateString()),
    systemOrganization: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {
// 
};
export const DBDef_Organization = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'organizations',
    entityName: 'Organization',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'organization'
    },
    backend: {
        name: 'organizations'
    },
};
//# sourceMappingURL=db-def.js.map